import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/equipment/carMountedFacialRecognition/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/equipment/carMountedFacialRecognition/detail',
    method: 'get',
    params: data,
  })
}
export async function createData(data) {
  return request({
    url: '/equipment/carMountedFacialRecognition/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/equipment/carMountedFacialRecognition/edit',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/equipment/carMountedFacialRecognition/delete',
    method: 'post',
    data,
  })
}
